import React, { useState, useEffect } from 'react';
import { fetchAPI } from '../../utils/api';

const Footer = ({ className = "footer-area", scrollToTopText = "Scroll to Top", scrollToTopTarget = "#header" }) => {
	const [footerData, setFooterData] = useState({
		copyrightText: "© 2025 Bridges of Justice, All Rights Reserved.",
		socialLinks: []
	});

	useEffect(() => {
		const getFooterData = async () => {
			try {
				const global = await fetchAPI('/global', {
					populate: 'socialLinks'
				});
				if (global?.data) {
					const { footerCopyright, socialLinks } = global.data;
					setFooterData({
						copyrightText: footerCopyright || "© 2025 Bridges of Justice, All Rights Reserved.",
						socialLinks: socialLinks || []
					});
				}
			} catch (error) {
				console.warn("Could not fetch footer data (likely missing in Strapi), using defaults.", error.message);
				// Fallback is already initial state, so no action needed, just suppress error
			}
		};
		getFooterData();
	}, []);

	return (
		<footer className={`${className}`}>
			<div className="container">
				<div className="row">
					<div className="col-12">
						<div className="footer-content d-flex flex-wrap justify-content-center justify-content-md-between align-items-center py-4">
							{/* Copyright */}
							<div className="copyright">
								{footerData.copyrightText}
								{footerData.socialLinks.map((link, index) => (
									<React.Fragment key={index}>
										{" "}<a href={link.url} target="_blank" rel="noopener noreferrer">{link.platform}</a>
									</React.Fragment>
								))}
							</div>
							{/* Scroll To Top */}
							<div id="scroll-to-top" className="scroll-to-top mt-3 mt-sm-0">
								<a href={scrollToTopTarget} className="smooth-anchor">{scrollToTopText}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
